import { Component } from '@angular/core';
import { PageLoaderService } from './services/page-loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'telemedicina';


    constructor(public pageLoader: PageLoaderService) {}


}

